import * as React from 'react';

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ManagerContext } from '../contexts/ManagerContext';
import { OpenAiContext } from '../contexts/OpenAiContext';
import Main from './Main';
import { Typography } from '@mui/material';
import mosaicGuardians from '../image/mosaicGuardians.png';
import { useWS } from '../contexts/ManagerContext';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Login from '../components/Auth/login';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import Avatar from '@mui/material/Avatar';
import MenuIcon from '@mui/icons-material/Menu';
import SideMenuMobile from '../components/AuthUI/SideMenuMobile';
import useMediaQuery from '@mui/material/useMediaQuery';
import BrandName from '../components/AuthUI/BrandName';
import Header from './Header';

import SideMenu from '../components/AuthUI/SideMenu';
import MenuTop from './MenuTop';



const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open' && prop !== 'isSmall',
  })(({ theme, isSmall, visible }) => ({
  
  zIndex: theme.zIndex.drawer,
  height: '70px',
  backgroundColor: 'rgba(28, 28, 28, 0.38)',
  boxShadow: 3,
  opacity: visible,
  backdropFilter: 'blur(5px)',
  transition: theme.transitions.create(['width', 'margin', 'opacity'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        marginLeft: drawerWidth,
        width: isSmall? '100%':`calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
    {
      props: ({ open }) => !open,
      style: {
        marginLeft: 70,
        width: isSmall? '100%':`calc(100% - ${70}px)`,
        [theme.breakpoints.up('sm')]: {
          marginLeft: `calc(${theme.spacing(8)} + 1px)`,
        },
      },
    },
  ],
}));

export default function MiniDrawer() {
  const { currentUser, currentPage, logout, isInit } = React.useContext(ManagerContext);
  const { chat } = React.useContext(OpenAiContext);
  const { sendAuthSkill } = useWS();
  const theme = useTheme();
  const [ open, setOpen ] = React.useState(false);
  const [ visible, setVisible ] = React.useState(0);


    // Użycie useMediaQuery do określenia obecnego rozmiaru
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'));
  const is_xs = useMediaQuery(theme.breakpoints.down('xs'));

  React.useEffect (() => {
    setOpen(isSmall||is_xs?false:true);
  }, [])

  const handleDrawerClose = (auto=false) => {
    if (auto && !is_xs && !isSmall) return;
    setOpen(false);
  };

  const handleDrawerToggle = () => {
    setOpen(!open);
  };

  React.useEffect( () => {
    if ( currentUser || true ){
      setVisible(1);
    } else {
      setVisible(0);
    }
  }, [ currentUser ])
  
  return (
    
      
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <CssBaseline enableColorScheme />  
        {(currentUser || true) && isInit && <AppBar position="fixed" open={open} isSmall={isSmall} visible={visible}>
          
          <Toolbar sx={{ alignSelf: 'center', width:'100%', height: '100%' }}>
          <IconButton
            aria-label="open drawer"
            onClick={handleDrawerToggle}
            // edge="start"
            sx={[
              {
                marginRight: 5,
                color: 'white',
              },
              open && { display: 'none' },
              !open && { display: {xs: 'flex', sm: 'none'} },
              {position: 'absolute'}
            ]}
            >
            <MenuIcon />
          </IconButton>
            
            {/* <Typography>
              {chat.activeThread?.id}
            </Typography> */}
            <div style={{ width: '100%', display:'flex', justifyContent: 'center' }}>
              
              <MenuTop  />
            </div>
            
            <Box sx={{ flexGrow: 1 }} />
            
          </Toolbar>
          
        </AppBar>}
        {isSmall && (currentUser || true) && isInit &&<SideMenuMobile open={open} handleDrawerToggle={handleDrawerToggle} handleDrawerClose={handleDrawerClose} visible={visible} currentUser={currentUser}  />}
        {!isSmall && (currentUser || true) && isInit && <SideMenu currentPage={currentPage} open={open} handleDrawerToggle={handleDrawerToggle} handleDrawerClose={handleDrawerClose} visible={visible} currentUser={currentUser}  />}
        <Main open={open} isSmall={isSmall}/>

      </Box>
  );
}